import { useEffect } from "react";

const useWheel = (callback: () => void) => {
    useEffect(() => {
        document.addEventListener("wheel", callback, { passive: true });
        return () => {
            document.removeEventListener("wheel", callback);
        };
    }, []);
};

export default useWheel;
